import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import useDelete from "../../../../hook/useDelete";
import useConfirm from "../../../../hook/useConfirm";
import { useEffect, useRef, useState } from "react";
import { CustomImagePopup } from "../../../../components/CustomImagePopup";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { validateMin } from "../../../../utils/validateMin";
import { CustomSearchableDropdown } from "../../../../components/CustomSearchableDropdown";


export const EditTireProduct = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [price, setPrice] = useState<number>(0);
    const [sku, setSku] = useState<string>("");
    const [file, setFile] = useState<FileList | null>(null);
    const [filePath, setFilePath] = useState<string>("");
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [brandId, setBrandId] = useState<number>(0);
    const [modelId, setModelId] = useState<number>(0);
    const [brands, setBrands] = useState<any[]>([]);
    const [models, setModels] = useState<any[]>([]);
    //Tire Size width
    const [tireWidthLabel, setTireWidthLabel] = useState<string>("");
    const [tireWidthLoadingMore, setTireWidthLoadingMore] = useState(false);
    const [tireWidthPage, setTireWidthPage] = useState(1);
    const [tireWidthHasMore, setTireWidthHasMore] = useState(true);
    const [tireWidthInitialLoading, setTireWidthInitialLoading] = useState(false);
    const [tireWidthResults, setTireWidthResults] = useState<any[]>([]);
    const [tireWidthSearchQuery, setTireWidthSearchQuery] = useState<string>("");
    //Tire Size ratio
    const [tireRatioLabel, setTireRatioLabel] = useState<string>("");
    const [tireRatioLoadingMore, setTireRatioLoadingMore] = useState(false);
    const [tireRatioPage, setTireRatioPage] = useState(1);
    const [tireRatioHasMore, setTireRatioHasMore] = useState(true);
    const [tireRatioInitialLoading, setTireRatioInitialLoading] = useState(false);
    const [tireRatioResults, setTireRatioResults] = useState<any[]>([]);
    const [tireRatioSearchQuery, setTireRatioSearchQuery] = useState<string>("");

    //Tire Size diameter
    const [tireDiameterLabel, setTireDiameterLabel] = useState<string>("");
    const [tireDiameterLoadingMore, setTireDiameterLoadingMore] = useState(false);
    const [tireDiameterPage, setTireDiameterPage] = useState(1);
    const [tireDiameterHasMore, setTireDiameterHasMore] = useState(true);
    const [tireDiameterInitialLoading, setTireDiameterInitialLoading] = useState(false);
    const [tireDiameterResults, setTireDiameterResults] = useState<any[]>([]);
    const [tireDiameterSearchQuery, setTireDiameterSearchQuery] = useState<string>("");
    const [tireFitmentId, setTireFitmentId] = useState<number>(0);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const inputFileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (tireFitmentId === 0) {
            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
    }, [tireFitmentId])

    useEffect(() => {
        if (!tireWidthLabel.length && !tireWidthSearchQuery.length) {
            setTireWidthPage(1)
            setTireWidthHasMore(true);
            setTireWidthResults([]);
            setTireWidthSearchQuery("");
            setTireWidthLabel("");

            setTireFitmentId(0)
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireWidthLabel, tireWidthSearchQuery])


    useEffect(() => {
        if (!tireRatioLabel.length && !tireRatioSearchQuery.length) {
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");

            setTireFitmentId(0)
            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireRatioLabel, tireRatioSearchQuery])


    useEffect(() => {
        setPleaseWaitPopup(true);
        axios.get(`${baseURL}tireBrands`)
            .then((response) => {
                setBrands(response?.data?.map((item: any) => {
                    return { value: item.brandId, label: item.brandName }
                }))
                setPleaseWaitPopup(false);
            }).catch(error => {
                setBrandId(0);
                setBrands([]);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (brandId > 0) {
            setPleaseWaitPopup(true);
            axios.get(`${baseURL}tireModels/GetTireModelsByTireBrandId/${brandId}`)
                .then((response) => {
                    setModels(response?.data?.map((item: any) => {
                        return { value: item.modelId, label: item.modelName }
                    }))
                    setPleaseWaitPopup(false);
                }).catch(error => {
                    setModelId(0);
                    setBrands([]);
                    console.error(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandId])

    useEffect(() => {
        if (isFirstTime && tireFitmentId > 0) {
            setPleaseWaitPopup(true);
            axios.get(`${baseURL}tireFitments/${tireFitmentId}`)
                .then((response) => {
                    setTireWidthLabel(String(response?.data?.metricWidth));
                    setTireWidthSearchQuery(String(response?.data?.metricWidth));
                    setTireRatioLabel(String(response?.data?.aspectRatio));
                    setTireRatioSearchQuery(String(response?.data?.aspectRatio));
                    setTireDiameterLabel(String(response?.data?.diameter));
                    setTireDiameterSearchQuery(String(response?.data?.diameter));
                    setPleaseWaitPopup(false);
                    setIsFirstTime(false);
                }).catch(error => {
                    setTireFitmentId(0);
                    setBrands([]);
                    console.error(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFirstTime, tireFitmentId])

    const tireWidthFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {

        if (tireWidthLoadingMore) return;
        if (!tireWidthHasMore && !isFresh) return;
        if (isFresh) {
            setTireWidthInitialLoading(true);
            setTireWidthHasMore(true);
        } else {
            setTireWidthLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`

            : `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&position=${false}`

        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.metricWidth)
                }
            }) || [];

            setTireWidthResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireWidthHasMore(list.length === pageSize);
            setTireWidthPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireWidthLoadingMore(false);
            setTireWidthInitialLoading(false);
        }

    };


    const tireRatioFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireWidthLabel) return;
        if (tireRatioLoadingMore) return;
        if (!tireRatioHasMore && !isFresh) return;
        if (isFresh) {
            setTireRatioInitialLoading(true);
            setTireRatioHasMore(true);
        } else {
            setTireRatioLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`
            : `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&position=${false}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.aspectRatio)
                }
            }) || [];

            setTireRatioResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireRatioHasMore(list.length === pageSize);
            setTireRatioPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireRatioLoadingMore(false);
            setTireRatioInitialLoading(false);
        }


    };


    const tireDiameterFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireRatioLabel || !tireWidthLabel) return;
        if (tireDiameterLoadingMore) return;
        if (!tireDiameterHasMore && !isFresh) return;
        if (isFresh) {
            setTireDiameterInitialLoading(true);
            setTireDiameterHasMore(true);
        } else {
            setTireDiameterLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`
            : `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`



        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.diameter)
                }
            }) || [];

            setTireDiameterResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireDiameterHasMore(list.length === pageSize);
            setTireDiameterPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireDiameterLoadingMore(false);
            setTireDiameterInitialLoading(false);
        }

    };


    useEffect(() => {
        if (Number(idNumber?.state) > 0) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}tireProducts/${idNumber?.state}`)
                .then((response) => {
                    setBrandId(response?.data?.brandId)
                    setModelId(response?.data?.modelId)
                    setTireFitmentId(response?.data?.tireFitmentId)
                    setSku(response?.data?.sku)
                    setPrice(response?.data?.price)
                    setFilePath(response?.data?.productImage ? response?.data?.productImage : "")
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (tireFitmentId === 0) {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please select a tire size.",
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {
                    callback();
                }
            })
            return;
        }
        setPleaseWaitPopup(true);
        if (file) {
            const formData = new FormData();
            formData.append("ImageFile", file[0]);

            try {
                const response = await axios.post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: false,
                });
                saveTireProduct(response.data);

            } catch (err) {
                setConfirmData({
                    title: 'Warning',
                    summary: "An error occurred while uploading the image. Please try again.",
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);

                setPleaseWaitPopup(false);
            }


        }
        else {
            saveTireProduct("");
        }
    }

    const saveTireProduct = (imageFile: string) => {
        axios
            .put(
                `${baseURL}tireProducts?userId=${auth?.id}`,
                JSON.stringify({
                    tireId: idNumber?.state,
                    brandId,
                    modelId,
                    tireFitmentId,
                    sku,
                    price,
                    productImage: imageFile ? imageFile : filePath
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        /*Selected files data can be collected here.*/
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles && selectedFiles.length > 0) {
            const file = selectedFiles[0];
            const fileName = file.name.toLowerCase();

            const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

            const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

            if (isSupported) {
                setFile(selectedFiles);
            } else {
                console.error('Unsupported file type');
                setConfirmData({
                    title: 'Warning',
                    summary: "Unsupported file type",
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);
            }
        }
    };


    const handleDeleteImage = () => {
        setDeleteData({
            id: 0,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Image?`,
            isDelete: async (callback: any) => {
                if (inputFileRef.current) {
                    inputFileRef.current.value = '';
                }

                if (filePath) {
                    setFilePath("")
                }
                setFile(null);

                callback();
            }
        });

        setDeletePopup(true);
    }

    const deletingTireProduct = async () => {

        setDeleteData({
            id: idNumber?.state,
            title: `Delete`,
            summary: `Are you sure you want to delete this tire product?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}tireProducts?id=${idNumber?.state}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Product</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Brand</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={brandId}
                                                onChange={(e) => setBrandId(Number(e.target.value))}
                                                required
                                            >
                                                {brands?.map((brand: any) => (
                                                    <option key={brand.value} value={brand.value}>
                                                        {brand.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                        <div className="grid grid-cols-3 gap-3">
                                            <CustomSearchableDropdown
                                                label="Width"
                                                selectedOptionLabel={tireWidthLabel}
                                                setSelectedOptionLabel={setTireWidthLabel}
                                                placeholder="Search Width"
                                                onDemandData={true}
                                                setResults={setTireWidthResults}
                                                results={tireWidthResults}
                                                fetchData={tireWidthFetchData}
                                                setSearchQuery={setTireWidthSearchQuery}
                                                searchQuery={tireWidthSearchQuery}
                                                initialLoading={tireWidthInitialLoading}
                                                loadingMore={tireWidthLoadingMore}
                                                page={tireWidthPage}
                                                setPage={setTireWidthPage}
                                                hasMore={tireWidthHasMore}
                                                setHasMore={setTireWidthHasMore}
                                                inputClassNameProp="w-full p-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                labelClassNameProp="block text-xs font-medium text-secondary"
                                            />

                                            <CustomSearchableDropdown
                                                label="Ratio"
                                                selectedOptionLabel={tireRatioLabel}
                                                setSelectedOptionLabel={setTireRatioLabel}
                                                placeholder="Search Ratio"
                                                onDemandData={true}
                                                setResults={setTireRatioResults}
                                                results={tireRatioResults}
                                                fetchData={tireRatioFetchData}
                                                setSearchQuery={setTireRatioSearchQuery}
                                                searchQuery={tireRatioSearchQuery}
                                                initialLoading={tireRatioInitialLoading}
                                                loadingMore={tireRatioLoadingMore}
                                                page={tireRatioPage}
                                                setPage={setTireRatioPage}
                                                hasMore={tireRatioHasMore}
                                                setHasMore={setTireRatioHasMore}
                                                inputClassNameProp="w-full p-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                labelClassNameProp="block text-xs font-medium text-secondary"
                                            />

                                            <CustomSearchableDropdown
                                                label="Diameter"
                                                value={tireFitmentId}
                                                setValue={setTireFitmentId}
                                                selectedOptionLabel={tireDiameterLabel}
                                                setSelectedOptionLabel={setTireDiameterLabel}
                                                placeholder="Search Diameter"
                                                onDemandData={true}
                                                setResults={setTireDiameterResults}
                                                results={tireDiameterResults}
                                                fetchData={tireDiameterFetchData}
                                                setSearchQuery={setTireDiameterSearchQuery}
                                                searchQuery={tireDiameterSearchQuery}
                                                initialLoading={tireDiameterInitialLoading}
                                                loadingMore={tireDiameterLoadingMore}
                                                page={tireDiameterPage}
                                                setPage={setTireDiameterPage}
                                                hasMore={tireDiameterHasMore}
                                                setHasMore={setTireDiameterHasMore}
                                                inputClassNameProp="w-full p-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                labelClassNameProp="block text-xs font-medium text-secondary"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">price</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={price}
                                                placeholder="Price"
                                                onChange={(e) => setPrice(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Image</label>

                                            <div className="flex flex-row items-center gap-[5px]">
                                                {file && (
                                                    <img
                                                        src={URL.createObjectURL(file[0])}
                                                        width={40}
                                                        height={40}
                                                        alt="product"
                                                        className="cursor-pointer"
                                                        onClick={() => setImagePopup(true)}
                                                    />
                                                )}

                                                {filePath && (
                                                    <img
                                                        src={`${baseURL}commonFile/Get?name=${filePath}`}
                                                        width={40}
                                                        height={40}
                                                        alt="product"
                                                        className="cursor-pointer"
                                                        onClick={() => setImagePopup(true)}
                                                    />
                                                )}

                                                {
                                                    (filePath || file) && (
                                                        <span
                                                            className="material-symbols-outlined text-sm cursor-pointer hover:text-red-600"
                                                            onClick={handleDeleteImage}
                                                        >
                                                            do_not_disturb_on
                                                        </span>
                                                    )
                                                }

                                            </div>

                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={inputFileRef}
                                                onChangeCapture={onFileChangeCapture}
                                                className="hidden"
                                            />
                                            {
                                                (!filePath && !file) && (
                                                    <div className="flex flex-row gap-[8px] mt-[8px] cursor-pointer">
                                                        <p
                                                            className="border border-dashed border-black rounded-[3px] px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                            onClick={(e) => {
                                                                if (inputFileRef.current) {
                                                                    inputFileRef.current.value = "";
                                                                }
                                                                inputFileRef.current?.click();
                                                            }}
                                                        >
                                                            <span className="material-symbols-outlined text-sm hover:text-primary">
                                                                add
                                                            </span>
                                                            Add Image
                                                        </p>
                                                    </div>
                                                )
                                            }

                                        </div>


                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Model</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={modelId}
                                                onChange={(e) => setModelId(Number(e.target.value))}
                                                required
                                            >
                                                {models?.map((model: any) => (
                                                    <option key={model.value} value={model.value}>
                                                        {model.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">SKU</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={sku}
                                                placeholder="SKU"
                                                onChange={(e) => setSku(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => deletingTireProduct()}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={filePath ? `${baseURL}commonFile/Get?name=${filePath}` : file ? URL.createObjectURL(file[0]) : ""}
                imageBaseUrlPath="commonFile"

            />
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}